<mat-dropdown
  [formControl]="formControl()"
  [options]="dropdownOptions()"
  [configurationInput]="dropdownSettings"
  [isFormSubmitted]="isFormSubmitted()"
  [isLoading]="!store.areFormFieldsLoaded()"
></mat-dropdown>
